<script>
export default {
  props: {
    title: {
      type: String
    },
    linkText: {
      type: String
    },
    linkUrl: {},
    list: {
      type: Array
    },
    gutter: {
      type: Number
    },
    span: {
      type: Number
    }
  },
  computed: {
    listStyle () {
      return { margin: `0 -${this.gutter}px` }
    },
    itemStyle () {
      return { padding: `0 ${this.gutter}px`, width: this.span / 12 * 100 + '%' }
    }
  }
}
</script>

<template>
  <div :class="$style.section">
    <div :class="$style.head">
      <h2 :class="$style.title">{{title}}</h2>
      <slot name="link">
        <router-link :to="linkUrl" :class="$style.linkUrl">
          {{linkText}}
          <i class="iconfont iconenter"></i>
        </router-link>
      </slot>
    </div>
    <div :class="$style.list" :style="listStyle">
      <template v-for="(item, index) in list">
        <div :class="$style.item" :key="item.id" :style="itemStyle">
          <slot :item="item" :index="index" />
        </div>
      </template>
    </div>
  </div>
</template>

<style lang="stylus" module>
.section
  page-gutter()

.head
  display flex
  justify-content space-between
  align-items flex-end
  padding 20px 0 10px

  /.title
    font-size 22px
    line-height 30px
    color #222222
    font-weight normal
    margin 0

  /.linkUrl
    color $gray-400
    small-font()

    :global(.iconfont)
      small-font()
      vertical-align top

.list
  display flex
  flex-flow row wrap
  padding-bottom 4px

  /.item
    margin-bottom 16px
</style>
